import { get, post } from "app/apis";
import DriverPriceRoutes from "./DriverPriceRoutes";

const DriverPriceService = {
  getDriver: async () => {
    const data = await get(DriverPriceRoutes.getDriver);
    return data;
  },
  createDriver: async (obj) => {
    const data = await post(DriverPriceRoutes.createDriver, obj);
    return data;
  },
  deleteDriver: async (obj) => {
    const data = await post(DriverPriceRoutes.deleteDriver, obj);
    return data;
  },
};

export default DriverPriceService;
